import React from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Filler, Legend } from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Filler, Legend);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: 'bottom',
      display: false
    },
    title: {
      display: true,
      text: 'Reward Distribution',
    },
  },
};

// Generating dummy data
const generateData = () => {
  const data = [];
  for (let i = 0; i < 5; i++) { // 7 is the number of labels (months)
    data.push(Math.floor(Math.random() * 1000));  
  }
  return data;
};

const labels = [ 
     '01/02', '03/03', '04/05', '04/07', '07/07', '05/06', '08/09',
      '01/02', '03/03', '04/05', '04/07', '07/07', '05/06', '08/09'
    ];

export const data = {
  labels,
  datasets: [
    {
      fill: true,
      label: 'Dataset 2',
      data: generateData(),
      borderColor: 'rgba(252, 154, 69,0.6)',
      backgroundColor: 'rgba(252, 154, 69,0.3)',
    },
  ],
};

const CreditUsage = () => {
  return (
    <Line height={100} options={options} data={data} />
  );
};

export default CreditUsage;
